// extracted by mini-css-extract-plugin
export var button = "_s-0";
export var buttonContent = "_s-d";
export var buttonGroup = "_s-b";
export var dontRestrainIconWidth = "_s-9";
export var dropdownButton = "_s-a";
export var iconContainer = "_s-8";
export var lg = "_s-4";
export var md = "_s-3";
export var pending = "_s-e";
export var sm = "_s-2";
export var spinner = "_s-c";
export var squared = "_s-7";
export var xl = "_s-5";
export var xs = "_s-1";
export var xxl = "_s-6";